"use client";

import { usePathname } from "next/navigation";
import MeasurementChart from "./MeasurementChart";

interface HeadingProps {
  data: {
    id: string;
    heading: string;
    description: string;
    useH1Tag?: boolean;
  };
}

export default function Heading({ data }: HeadingProps) {
  const pathname = usePathname();

  return (
    <div className="flex flex-col justify-center items-center gap-2 my-3">
      {/* Only show heading if not on /fitguide */}
      {pathname !== "/fitguide" && (
        <>
          {data?.useH1Tag ? (
            <h1 className="text-center text-3xl sm:text-4xl lg:text-5xl font-bold p-2 text-black">
              {data?.heading}
            </h1>
          ) : (
            <h2 className="text-center 2xl:text-4xl xl:text-4xl lg:text-4xl md:text-4xl text-3xl font-bold p-2 text-th-primary font-arial">
              {data?.heading}
            </h2>
          )}
        </>
      )}

      {data?.description && (
        <p className="text-[14px] text-th-subtitle-col-2">
          {data?.description}
        </p>
      )}

      {/* Show chart only on /fitguide */}
      {pathname === "/fitguide" && <MeasurementChart />}
    </div>
  );
}
